import Styles from "./ColorStrip.module.scss"
import { colorOptions } from '../../constants/constants'

const ColorStrip = () => {
    
    
    const handleAccentColor=(colorValue:any)=>{
        document.documentElement.style.setProperty(('--skin-color'),`rgb(${colorValue})`)
        document.documentElement.style.setProperty(('--skin-c'),colorValue)
    }


    return (<div className={Styles.color_strip}>
        {colorOptions.map((color) => {
            return (
                <div key={color.id || color.color} className={(Styles.color_option)} style={{ backgroundColor: `rgb(${color.color})` }} onClick={() => {handleAccentColor(color.color) }} />
            )
        })}
    </div>
    )
}

export default ColorStrip
